var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/Node/UserClassifierRepo.ts";
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
export var isUserClassifierNode = function isUserClassifierNode(node) {
  return node.type === 'UserClassifierNode';
};
export var isUserClassifierGroupNode = function isUserClassifierGroupNode(node) {
  return isUserClassifierGroupWithGroupsNode(node) || isUserClassifierGroupWithElementsNode(node) || isUserClassifierEmptyGroupNode(node);
};
export var isUserClassifierGroupWithGroupsNode = function isUserClassifierGroupWithGroupsNode(node) {
  return node.type === 'UserClassifierGroupWithGroupsNode';
};
export var isUserClassifierGroupWithElementsNode = function isUserClassifierGroupWithElementsNode(node) {
  return node.type === 'UserClassifierGroupWithElementsNode';
};
export var isUserClassifierEmptyGroupNode = function isUserClassifierEmptyGroupNode(node) {
  return node.type === 'UserClassifierEmptyGroupNode';
};
export var isDynamicGroupNode = function isDynamicGroupNode(node) {
  return isDynamicBaseGroupNode(node) || isDynamicGeneratedGroupNode(node);
};
export var isDynamicBaseGroupNode = function isDynamicBaseGroupNode(node) {
  return node.type === 'DynamicBaseGroupNode';
};
export var isDynamicGeneratedGroupNode = function isDynamicGeneratedGroupNode(node) {
  return node.type === 'DynamicGeneratedGroupNode';
};
export var isAssemblyClassifierNode = function isAssemblyClassifierNode(node) {
  return node.type === 'AssemblyClassifierNode';
};